import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from 'i18next';

import { getTheme } from '../../core/config/themeConfig';
import { Languages } from '../../core/enums/languages';
import { Themes } from '../../core/enums/themes';
import { RootState } from '../../core/store/store';

interface SettingsState {
  isDarkMode: boolean;
  currentLanguage: Languages;
}

export const initialSettingsState: SettingsState = {
  isDarkMode: localStorage.getItem('theme') === Themes.DARK ? true : false,
  currentLanguage: Languages.HU,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialSettingsState,
  reducers: {
    setDarkModeTo(state: SettingsState, action: PayloadAction<{ isDarkMode: boolean }>) {
      state.isDarkMode = action.payload.isDarkMode;
    },
    toggleTheme(state: SettingsState) {
      state.isDarkMode = !state.isDarkMode;
    },
    setLanguageTo(state: SettingsState, action: PayloadAction<{ language: Languages }>) {
      i18n.changeLanguage(action.payload.language);
      state.currentLanguage = action.payload.language;
    },
  },
});

export const settingsActions = settingsSlice.actions;
export const settingsReducers = settingsSlice.reducer;
export const selectSettingsState = (state: RootState) => state.settings;
export const selectConfigLoaderState = (state: RootState) => state.configLoader;
export const selectCurrentLanguage = (state: RootState) => selectSettingsState(state).currentLanguage;
export const selectIsDarkMode = (state: RootState) => selectSettingsState(state).isDarkMode;

const selectCompany = (state: RootState) => selectConfigLoaderState(state).appConfig.vendor;
export const selectCurrentTheme = createSelector([selectSettingsState, selectCompany], (settings, company) => {
  return getTheme(company, settings.isDarkMode);
});
